import React from 'react';
import PropTypes from 'prop-types';
import { Bar } from 'react-chartjs-2';
import { makeStyles } from '@material-ui/styles';
import {
  CardContent,
} from '@material-ui/core';
import {themeColorText} from '../../../src/App'

import palette from './palette';



const LatestSales = props => {
const useStyles = makeStyles(() => ({
  root: {},
  chartContainer: {
    height: props.width,
    position: 'relative'
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

function GetLabelsDiagram(props)
{ 
  var stat = props.diagramstat;
  var data = stat.map(stat => (
    stat.month + "-" + stat.year
  ))
  return data;
}

function GetDataDiagram(props)
{
  var stat = props.diagramstat;
  var data = stat.map(stat => (   
    stat.pointAmount
))
  return data;
}
const data = {
  labels: GetLabelsDiagram(props),
  datasets: [
    {
      label: '',
      backgroundColor: themeColorText.color,
      data: GetDataDiagram(props)
    },
  ]
};

const options = {
  responsive: true,
  maintainAspectRatio: false,
  animation: false,
  legend: { display: false },
  cornerRadius: 20,
  tooltips: {
    enabled: true,
    mode: 'index',
    intersect: false,
    borderWidth: 1,
    borderColor: palette.divider,
    backgroundColor: palette.white,
    titleFontColor: palette.text.primary,
    bodyFontColor: palette.text.secondary,
    footerFontColor: palette.text.secondary
  },
  layout: { padding: 0 },
  scales: {
    xAxes: [
      {
        barThickness: props.barThickness == null ? 18 : props.barThickness,
        maxBarThickness: 90,
        barPercentage: 0.5,
        categoryPercentage: 0.5,
        ticks: {
          fontColor: palette.text.secondary,
        },
        gridLines: {
          display: false,
          drawBorder: false
        }
      }
    ],
    yAxes: [
      {
        ticks: {
          fontColor: palette.text.secondary,
          beginAtZero: true,
          min: 0
        },
        gridLines: {
          borderDash: [2],
          borderDashOffset: [2],
          color: palette.divider,
          drawBorder: false,
          zeroLineBorderDash: [2],
          zeroLineBorderDashOffset: [2],
          zeroLineColor: palette.divider
        }
      }
    ]
  }
};
const classes = useStyles();

  return (
      <div className={props.className}>
        <CardContent>
            <div className={classes.chartContainer}>
            <Bar
                data={data}
                options={options}
            />
            </div>
        </CardContent>
    </div>
  );
};

LatestSales.propTypes = {
  className: PropTypes.string
};

export default LatestSales;
